// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import {
//   createGSTRate,
//   getAllGSTRates,
//   updateGSTRate,
//   deleteGSTRate,
//   getActiveGSTRates,
//   getGSTConfig,
//   updateGSTConfig,
//   calculateGST,
//   getCurrentRatesForService,
//   getGSTRateHistory,
//   getGSTSummary,
//   bulkCreateGSTRates
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/GSTManagement.css';

// const SkeletonStatsCard = () => (
//   <div className="summary-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>S.No</th>
//           <th>Tax Type</th>
//           <th>Service Type</th>
//           <th>Rate (%)</th>
//           <th>HSN/SAC</th>
//           <th>Applicable From</th>
//           <th>Applicable To</th>
//           <th>Priority</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonConfigForm = () => (
//   <div className="config-form skeleton">
//     <div className="form-section">
//       <div className="skeleton-section-title"></div>
//       <div className="form-row">
//         <div className="form-group"><div className="skeleton-input"></div></div>
//         <div className="form-group"><div className="skeleton-input"></div></div>
//       </div>
//       <div className="form-row">
//         <div className="form-group"><div className="skeleton-input"></div></div>
//         <div className="form-group"><div className="skeleton-input"></div></div>
//       </div>
//     </div>
//     <div className="form-section">
//       <div className="skeleton-section-title"></div>
//       {[1, 2, 3, 4].map((i) => (
//         <div key={i} className="service-rates">
//           <div className="skeleton-subtitle"></div>
//           <div className="form-row">
//             <div className="form-group"><div className="skeleton-checkbox"></div></div>
//             <div className="form-group"><div className="skeleton-input"></div></div>
//             <div className="form-group"><div className="skeleton-input"></div></div>
//             <div className="form-group"><div className="skeleton-input"></div></div>
//           </div>
//         </div>
//       ))}
//     </div>
//     <div className="form-actions">
//       <div className="skeleton-button"></div>
//     </div>
//   </div>
// );

// const SkeletonCalculator = () => (
//   <div className="calculator-container skeleton">
//     <div className="calculator-form">
//       <div className="skeleton-title"></div>
//       <div className="form-group"><div className="skeleton-input"></div></div>
//       <div className="form-group"><div className="skeleton-select"></div></div>
//       <div className="form-group"><div className="skeleton-input"></div></div>
//       <div className="form-group"><div className="skeleton-input"></div></div>
//       <div className="skeleton-button"></div>
//     </div>
//     <div className="calculator-result">
//       <div className="skeleton-title"></div>
//       <div className="result-card">
//         {[1, 2, 3, 4].map((i) => (
//           <div key={i} className="skeleton-result-row"></div>
//         ))}
//       </div>
//     </div>
//   </div>
// );

// const SkeletonReports = () => (
//   <div className="tab-content">
//     <div className="summary-cards">
//       {[1, 2, 3].map((i) => (
//         <SkeletonStatsCard key={i} />
//       ))}
//     </div>
//     <div className="reports-section">
//       <div className="skeleton-section-title"></div>
//       <div className="current-rates-grid">
//         {[1, 2, 3, 4].map((i) => (
//           <div key={i} className="rate-card skeleton">
//             <div className="skeleton-subtitle"></div>
//             {[1, 2, 3].map((j) => (
//               <div key={j} className="rate-item">
//                 <div className="skeleton-badge"></div>
//                 <div className="skeleton-cell"></div>
//               </div>
//             ))}
//           </div>
//         ))}
//       </div>
//     </div>
//     <div className="reports-section">
//       <div className="skeleton-section-title"></div>
//       <div className="table-container">
//         <div className="skeleton-table-header"></div>
//         {[1, 2, 3, 4, 5].map((i) => (
//           <div key={i} className="skeleton-history-row"></div>
//         ))}
//       </div>
//     </div>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4, 5, 6].map((i) => (
//           <div key={i} className="form-group">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-input"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const GSTManagement = () => {
//   const { token } = useSelector(state => state.user);
  
//   const [activeTab, setActiveTab] = useState('rates');
//   const [rates, setRates] = useState([]);
//   const [config, setConfig] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);
  
//   const [showRateModal, setShowRateModal] = useState(false);
//   const [showBulkModal, setShowBulkModal] = useState(false);
//   const [editingRate, setEditingRate] = useState(null);
//   const [viewingRate, setViewingRate] = useState(null);
  
//   const [rateForm, setRateForm] = useState({
//     taxType: 'CGST',
//     serviceType: 'ac_bus',
//     rate: '',
//     hsnSacCode: '9964',
//     description: '',
//     applicableFrom: new Date().toISOString().split('T')[0],
//     applicableTo: '',
//     priority: 0
//   });
  
//   const [bulkRates, setBulkRates] = useState([]);
//   const [bulkRatesText, setBulkRatesText] = useState('');
  
//   const [calculator, setCalculator] = useState({
//     amount: '',
//     serviceType: 'ac_bus',
//     placeOfSupply: '',
//     placeOfConsumption: ''
//   });
//   const [calculationResult, setCalculationResult] = useState(null);
  
//   const [filters, setFilters] = useState({
//     taxType: '',
//     serviceType: '',
//     isActive: 'true'
//   });
  
//   const [pagination, setPagination] = useState({
//     page: 1,
//     limit: 20,
//     total: 0,
//     pages: 0
//   });
  
//   const [rateHistory, setRateHistory] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [currentRates, setCurrentRates] = useState({});
  
//   const serviceTypes = [
//     { value: 'ac_bus', label: 'AC Bus' },
//     { value: 'non_ac_bus', label: 'Non-AC Bus' },
//     { value: 'luxury_bus', label: 'Luxury Bus' },
//     { value: 'sleeper_bus', label: 'Sleeper Bus' }
//   ];
  
//   const taxTypes = ['CGST', 'SGST', 'IGST'];
  
//   useEffect(() => {
//     fetchAllData();
//   }, [activeTab, filters, pagination.page]);
  
//   const fetchAllData = async () => {
//     if (activeTab === 'rates') {
//       await fetchRates();
//     } else if (activeTab === 'config') {
//       await fetchConfig();
//     } else if (activeTab === 'reports') {
//       await fetchReports();
//     }
//   };
  
//   // ✅ FIXED: fetchRates with safe data access
//   const fetchRates = async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       const response = await getAllGSTRates({
//         page: pagination.page,
//         limit: pagination.limit,
//         taxType: filters.taxType,
//         serviceType: filters.serviceType,
//         isActive: filters.isActive
//       }, token);
      
//       if (response && response.success) {
//         // ✅ Safe access with optional chaining and fallbacks
//         setRates(response.data?.rates || []);
//         setPagination(prev => ({
//           ...prev,
//           total: response.data?.pagination?.total || 0,
//           pages: response.data?.pagination?.pages || 0
//         }));
//       } else {
//         // ✅ Handle success: false case
//         setError(response?.message || 'Failed to fetch GST rates');
//         setRates([]);
//         setPagination(prev => ({ ...prev, total: 0, pages: 0 }));
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to fetch GST rates');
//       console.error(err);
//       setRates([]);
//       setPagination(prev => ({ ...prev, total: 0, pages: 0 }));
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   // ✅ FIXED: fetchConfig with safe data access
//   const fetchConfig = async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       const response = await getGSTConfig(token);
      
//       if (response && response.success) {
//         setConfig(response.data || null);
//       } else {
//         setError(response?.message || 'Failed to fetch GST configuration');
//         setConfig(null);
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to fetch GST configuration');
//       console.error(err);
//       setConfig(null);
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   // ✅ FIXED: fetchReports with safe data access
//   const fetchReports = async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       const [historyRes, summaryRes, currentRatesRes] = await Promise.all([
//         getGSTRateHistory(token),
//         getGSTSummary(token),
//         getActiveGSTRates(token)
//       ]);
      
//       if (historyRes && historyRes.success) {
//         setRateHistory(historyRes.data?.history || []);
//       } else {
//         setRateHistory([]);
//       }
      
//       if (summaryRes && summaryRes.success) {
//         setSummary(summaryRes.data || null);
//       } else {
//         setSummary(null);
//       }
      
//       if (currentRatesRes && currentRatesRes.success) {
//         setCurrentRates(currentRatesRes.data?.grouped || {});
//       } else {
//         setCurrentRates({});
//       }
//     } catch (err) {
//       setError('Failed to fetch reports');
//       console.error(err);
//       setRateHistory([]);
//       setSummary(null);
//       setCurrentRates({});
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   // ✅ FIXED: handleCreateRate with else branch
//   const handleCreateRate = async (e) => {
//     e.preventDefault();
//     try {
//       setLoading(true);
//       setError(null);
      
//       const response = await createGSTRate(rateForm, token);
      
//       if (response && response.success) {
//         setSuccess('GST rate created successfully');
//         setShowRateModal(false);
//         resetRateForm();
//         await fetchRates();
//         setTimeout(() => setSuccess(null), 3000);
//       } else {
//         setError(response?.message || 'Failed to create GST rate');
//         setTimeout(() => setError(null), 3000);
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to create GST rate');
//       setTimeout(() => setError(null), 3000);
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   // ✅ FIXED: handleUpdateRate with else branch
//   const handleUpdateRate = async (e) => {
//     e.preventDefault();
//     try {
//       setLoading(true);
//       setError(null);
      
//       const response = await updateGSTRate(editingRate._id, rateForm, token);
      
//       if (response && response.success) {
//         setSuccess('GST rate updated successfully');
//         setShowRateModal(false);
//         setEditingRate(null);
//         resetRateForm();
//         await fetchRates();
//         setTimeout(() => setSuccess(null), 3000);
//       } else {
//         setError(response?.message || 'Failed to update GST rate');
//         setTimeout(() => setError(null), 3000);
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to update GST rate');
//       setTimeout(() => setError(null), 3000);
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   // ✅ FIXED: handleDeleteRate with else branch
//   const handleDeleteRate = async (id) => {
//     if (!window.confirm('Are you sure you want to deactivate this GST rate?')) {
//       return;
//     }
    
//     try {
//       setLoading(true);
//       setError(null);
      
//       const response = await deleteGSTRate(id, token);
      
//       if (response && response.success) {
//         setSuccess('GST rate deactivated successfully');
//         await fetchRates();
//         setTimeout(() => setSuccess(null), 3000);
//       } else {
//         setError(response?.message || 'Failed to deactivate GST rate');
//         setTimeout(() => setError(null), 3000);
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to deactivate GST rate');
//       setTimeout(() => setError(null), 3000);
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   // ✅ FIXED: handleEditRate with safe access
//   const handleEditRate = (rate) => {
//     setEditingRate(rate);
//     setRateForm({
//       taxType: rate.taxType,
//       serviceType: rate.serviceType,
//       rate: rate.rate,
//       hsnSacCode: rate.hsnSacCode || '9964',
//       description: rate.description || '',
//       applicableFrom: rate.applicableFrom?.split('T')[0] || new Date().toISOString().split('T')[0],
//       applicableTo: rate.applicableTo?.split('T')[0] || '',
//       priority: rate.priority || 0
//     });
//     setShowRateModal(true);
//   };
  
//   const handleViewRate = (rate) => {
//     setViewingRate(rate);
//   };
  
//   // ✅ FIXED: handleUpdateConfig with else branch
//   const handleUpdateConfig = async (e) => {
//     e.preventDefault();
//     try {
//       setLoading(true);
//       setError(null);
      
//       const response = await updateGSTConfig(config, token);
      
//       if (response && response.success) {
//         setSuccess('GST configuration updated successfully');
//         setTimeout(() => setSuccess(null), 3000);
//       } else {
//         setError(response?.message || 'Failed to update configuration');
//         setTimeout(() => setError(null), 3000);
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to update configuration');
//       setTimeout(() => setError(null), 3000);
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   // ✅ FIXED: handleCalculateGST with else branch
//   const handleCalculateGST = async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       const response = await calculateGST(calculator, token);
      
//       if (response && response.success) {
//         setCalculationResult(response.data || null);
//       } else {
//         setError(response?.message || 'Failed to calculate GST');
//         setTimeout(() => setError(null), 3000);
//         setCalculationResult(null);
//       }
//     } catch (err) {
//       setError('Failed to calculate GST');
//       setTimeout(() => setError(null), 3000);
//       setCalculationResult(null);
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   // ✅ FIXED: handleBulkCreate with safe access and else branch
//   const handleBulkCreate = async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       const ratesArray = bulkRatesText.split('\n')
//         .filter(line => line.trim())
//         .map(line => {
//           const [taxType, serviceType, rate, ...rest] = line.split(',');
//           return {
//             taxType: taxType?.trim(),
//             serviceType: serviceType?.trim(),
//             rate: parseFloat(rate),
//             description: rest.join(',') || `${taxType} ${rate}% for ${serviceType}`
//           };
//         });
      
//       const response = await bulkCreateGSTRates(ratesArray, token);
      
//       if (response && response.success) {
//         const createdCount = response.data?.created?.length || 0;
//         setSuccess(`Created ${createdCount} rates successfully`);
//         setShowBulkModal(false);
//         setBulkRatesText('');
//         await fetchRates();
//         setTimeout(() => setSuccess(null), 3000);
//       } else {
//         setError(response?.message || 'Failed to bulk create rates');
//         setTimeout(() => setError(null), 3000);
//       }
//     } catch (err) {
//       setError('Failed to bulk create rates');
//       setTimeout(() => setError(null), 3000);
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   const resetRateForm = () => {
//     setRateForm({
//       taxType: 'CGST',
//       serviceType: 'ac_bus',
//       rate: '',
//       hsnSacCode: '9964',
//       description: '',
//       applicableFrom: new Date().toISOString().split('T')[0],
//       applicableTo: '',
//       priority: 0
//     });
//   };
  
//   const handleRateFormChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setRateForm(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };
  
//   const handleConfigChange = (e) => {
//     const { name, value } = e.target;
//     if (name.includes('.')) {
//       const [parent, child] = name.split('.');
//       setConfig(prev => ({
//         ...prev,
//         [parent]: {
//           ...prev[parent],
//           [child]: value
//         }
//       }));
//     } else {
//       setConfig(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     }
//   };
  
//   const handleConfigNestedChange = (category, field, value) => {
//     setConfig(prev => ({
//       ...prev,
//       defaultRates: {
//         ...prev.defaultRates,
//         [category]: {
//           ...prev.defaultRates[category],
//           [field]: typeof value === 'boolean' ? value : parseFloat(value) || 0
//         }
//       }
//     }));
//   };
  
//   const getStatusBadge = (isActive, applicableTo) => {
//     if (!isActive) return <span className="status-badge inactive">Inactive</span>;
//     if (applicableTo && new Date(applicableTo) < new Date()) {
//       return <span className="status-badge expired">Expired</span>;
//     }
//     return <span className="status-badge active">Active</span>;
//   };
  
//   const renderLoadingContent = () => {
//     switch (activeTab) {
//       case 'rates':
//         return <SkeletonTable />;
//       case 'config':
//         return <SkeletonConfigForm />;
//       case 'calculator':
//         return <SkeletonCalculator />;
//       case 'reports':
//         return <SkeletonReports />;
//       default:
//         return <SkeletonTable />;
//     }
//   };
  
//   return (
//     <div className="gst-management">
//       <div className="page-header">
//         <h1>GST Management</h1>
//         <div className="header-actions">
//           {activeTab === 'rates' && !loading && (
//             <>
//               <button className="btn-primary" onClick={() => setShowRateModal(true)}>
//                 + Add GST Rate
//               </button>
//               <button className="btn-secondary" onClick={() => setShowBulkModal(true)}>
//                 Bulk Import
//               </button>
//             </>
//           )}
//           {activeTab === 'rates' && loading && (
//             <>
//               <div className="skeleton-button-small"></div>
//               <div className="skeleton-button-small"></div>
//             </>
//           )}
//         </div>
//       </div>

//       {error && <div className="error-message">{error}</div>}
//       {success && <div className="success-message">{success}</div>}

//       <div className="gst-tabs">
//         <button className={activeTab === 'rates' ? 'tab active' : 'tab'} onClick={() => setActiveTab('rates')}>
//           GST Rates
//         </button>
//         <button className={activeTab === 'config' ? 'tab active' : 'tab'} onClick={() => setActiveTab('config')}>
//           Configuration
//         </button>
//         <button className={activeTab === 'calculator' ? 'tab active' : 'tab'} onClick={() => setActiveTab('calculator')}>
//           GST Calculator
//         </button>
//         <button className={activeTab === 'reports' ? 'tab active' : 'tab'} onClick={() => setActiveTab('reports')}>
//           Reports
//         </button>
//       </div>

//       {loading && activeTab !== 'config' && activeTab !== 'calculator' && renderLoadingContent()}

//       {activeTab === 'rates' && !loading && (
//         <div className="tab-content">
//           <div className="filters-bar">
//             <select
//               value={filters.taxType}
//               onChange={(e) => setFilters({ ...filters, taxType: e.target.value, page: 1 })}
//               className="filter-select"
//             >
//               <option value="">All Tax Types</option>
//               {taxTypes.map(type => (
//                 <option key={type} value={type}>{type}</option>
//               ))}
//             </select>
            
//             <select
//               value={filters.serviceType}
//               onChange={(e) => setFilters({ ...filters, serviceType: e.target.value, page: 1 })}
//               className="filter-select"
//             >
//               <option value="">All Service Types</option>
//               {serviceTypes.map(type => (
//                 <option key={type.value} value={type.value}>{type.label}</option>
//               ))}
//             </select>
            
//             <select
//               value={filters.isActive}
//               onChange={(e) => setFilters({ ...filters, isActive: e.target.value, page: 1 })}
//               className="filter-select"
//             >
//               <option value="true">Active Only</option>
//               <option value="false">Inactive Only</option>
//               <option value="">All</option>
//             </select>
            
//             <button className="refresh-btn" onClick={fetchRates}>Refresh</button>
//           </div>

//           <div className="table-container">
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>S.No</th>
//                   <th>Tax Type</th>
//                   <th>Service Type</th>
//                   <th>Rate (%)</th>
//                   <th>HSN/SAC</th>
//                   <th>Applicable From</th>
//                   <th>Applicable To</th>
//                   <th>Priority</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rates.length === 0 ? (
//                   <tr><td colSpan="10" className="no-data">No GST rates found</td></tr>
//                 ) : (
//                   rates.map((rate, index) => (
//                     <tr key={rate._id}>
//                       <td>{(pagination.page - 1) * pagination.limit + index + 1}</td>
//                       <td><span className={`tax-badge ${rate.taxType.toLowerCase()}`}>{rate.taxType}</span></td>
//                       <td>{serviceTypes.find(s => s.value === rate.serviceType)?.label || rate.serviceType}</td>
//                       <td className="rate-value">{rate.rate}%</td>
//                       <td>{rate.hsnSacCode}</td>
//                       <td>{new Date(rate.applicableFrom).toLocaleDateString()}</td>
//                       <td>{rate.applicableTo ? new Date(rate.applicableTo).toLocaleDateString() : 'Ongoing'}</td>
//                       <td>{rate.priority}</td>
//                       <td>{getStatusBadge(rate.isActive, rate.applicableTo)}</td>
//                       <td>
//                         <div className="action-buttons">
//                           <button className="action-btn view" onClick={() => handleViewRate(rate)}>View</button>
//                           <button className="action-btn edit" onClick={() => handleEditRate(rate)}>Edit</button>
//                           <button className="action-btn delete" onClick={() => handleDeleteRate(rate._id)}>Delete</button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {pagination.pages > 1 && (
//             <div className="pagination">
//               <button onClick={() => setPagination({ ...pagination, page: pagination.page - 1 })} disabled={pagination.page === 1}>
//                 Previous
//               </button>
//               <span>Page {pagination.page} of {pagination.pages}</span>
//               <button onClick={() => setPagination({ ...pagination, page: pagination.page + 1 })} disabled={pagination.page === pagination.pages}>
//                 Next
//               </button>
//             </div>
//           )}
//         </div>
//       )}

//       {activeTab === 'config' && !loading && config && (
//         <div className="tab-content">
//           <form onSubmit={handleUpdateConfig} className="config-form">
//             <div className="form-section">
//               <h3>Business Information</h3>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>GSTIN *</label>
//                   <input
//                     type="text"
//                     name="gstin"
//                     value={config.gstin || ''}
//                     onChange={handleConfigChange}
//                     placeholder="22AAAAA0000A1Z"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Legal Name *</label>
//                   <input
//                     type="text"
//                     name="legalName"
//                     value={config.legalName || ''}
//                     onChange={handleConfigChange}
//                     required
//                   />
//                 </div>
//               </div>
              
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Trade Name</label>
//                   <input
//                     type="text"
//                     name="tradeName"
//                     value={config.tradeName || ''}
//                     onChange={handleConfigChange}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Financial Year</label>
//                   <input
//                     type="text"
//                     name="financialYear"
//                     value={config.financialYear || ''}
//                     onChange={handleConfigChange}
//                     placeholder="2025-26"
//                   />
//                 </div>
//               </div>
              
//               <div className="form-section">
//                 <h4>Address</h4>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Street</label>
//                     <input
//                       type="text"
//                       value={config.address?.street || ''}
//                       onChange={(e) => setConfig({ ...config, address: { ...config.address, street: e.target.value } })}
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>City</label>
//                     <input
//                       type="text"
//                       value={config.address?.city || ''}
//                       onChange={(e) => setConfig({ ...config, address: { ...config.address, city: e.target.value } })}
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>State</label>
//                     <input
//                       type="text"
//                       value={config.address?.state || ''}
//                       onChange={(e) => setConfig({ ...config, address: { ...config.address, state: e.target.value } })}
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>State Code</label>
//                     <input
//                       type="text"
//                       value={config.address?.stateCode || ''}
//                       onChange={(e) => setConfig({ ...config, address: { ...config.address, stateCode: e.target.value } })}
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Pincode</label>
//                     <input
//                       type="text"
//                       value={config.address?.pincode || ''}
//                       onChange={(e) => setConfig({ ...config, address: { ...config.address, pincode: e.target.value } })}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
            
//             <div className="form-section">
//               <h3>Default GST Rates</h3>
//               {serviceTypes.map(service => (
//                 <div key={service.value} className="service-rates">
//                   <h4>{service.label}</h4>
//                   <div className="form-row">
//                     <div className="form-group">
//                       <label>Taxable?</label>
//                       <input
//                         type="checkbox"
//                         checked={config.defaultRates?.[service.value]?.isTaxable || false}
//                         onChange={(e) => handleConfigNestedChange(service.value, 'isTaxable', e.target.checked)}
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label>CGST (%)</label>
//                       <input
//                         type="number"
//                         step="0.1"
//                         value={config.defaultRates?.[service.value]?.cgst || 0}
//                         onChange={(e) => handleConfigNestedChange(service.value, 'cgst', e.target.value)}
//                         disabled={!config.defaultRates?.[service.value]?.isTaxable}
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label>SGST (%)</label>
//                       <input
//                         type="number"
//                         step="0.1"
//                         value={config.defaultRates?.[service.value]?.sgst || 0}
//                         onChange={(e) => handleConfigNestedChange(service.value, 'sgst', e.target.value)}
//                         disabled={!config.defaultRates?.[service.value]?.isTaxable}
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label>IGST (%)</label>
//                       <input
//                         type="number"
//                         step="0.1"
//                         value={config.defaultRates?.[service.value]?.igst || 0}
//                         onChange={(e) => handleConfigNestedChange(service.value, 'igst', e.target.value)}
//                         disabled={!config.defaultRates?.[service.value]?.isTaxable}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <div className="form-section">
//               <h3>Additional Settings</h3>
//               <div className="form-row">
//                 <div className="form-group checkbox">
//                   <label>
//                     <input
//                       type="checkbox"
//                       name="reverseChargeApplicable"
//                       checked={config.reverseChargeApplicable || false}
//                       onChange={handleConfigChange}
//                     />
//                     Reverse Charge Applicable
//                   </label>
//                 </div>
//                 <div className="form-group checkbox">
//                   <label>
//                     <input
//                       type="checkbox"
//                       name="isEcommerceOperator"
//                       checked={config.isEcommerceOperator || false}
//                       onChange={handleConfigChange}
//                     />
//                     E-commerce Operator
//                   </label>
//                 </div>
//               </div>
//             </div>
            
//             <div className="form-actions">
//               <button type="submit" className="btn-primary" disabled={loading}>
//                 {loading ? 'Saving...' : 'Save Configuration'}
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {activeTab === 'config' && loading && <SkeletonConfigForm />}

//       {activeTab === 'calculator' && !loading && (
//         <div className="tab-content">
//           <div className="calculator-container">
//             <div className="calculator-form">
//               <h3>GST Calculator</h3>
//               <div className="form-group">
//                 <label>Amount (₹)</label>
//                 <input
//                   type="number"
//                   value={calculator.amount}
//                   onChange={(e) => setCalculator({ ...calculator, amount: e.target.value })}
//                   placeholder="Enter amount"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label>Service Type</label>
//                 <select
//                   value={calculator.serviceType}
//                   onChange={(e) => setCalculator({ ...calculator, serviceType: e.target.value })}
//                 >
//                   {serviceTypes.map(type => (
//                     <option key={type.value} value={type.value}>{type.label}</option>
//                   ))}
//                 </select>
//               </div>
              
//               <div className="form-group">
//                 <label>Place of Supply (State Code)</label>
//                 <input
//                   type="text"
//                   value={calculator.placeOfSupply}
//                   onChange={(e) => setCalculator({ ...calculator, placeOfSupply: e.target.value })}
//                   placeholder="e.g., 27 for Maharashtra"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label>Place of Consumption (State Code)</label>
//                 <input
//                   type="text"
//                   value={calculator.placeOfConsumption}
//                   onChange={(e) => setCalculator({ ...calculator, placeOfConsumption: e.target.value })}
//                   placeholder="e.g., 27 for Maharashtra"
//                 />
//               </div>
              
//               <button className="btn-primary" onClick={handleCalculateGST} disabled={loading}>
//                 Calculate GST
//               </button>
//             </div>
            
//             {calculationResult && (
//               <div className="calculator-result">
//                 <h3>Calculation Result</h3>
//                 <div className="result-card">
//                   <div className="result-row">
//                     <span>Taxable Value:</span>
//                     <strong>₹{calculationResult.taxableValue?.toFixed(2)}</strong>
//                   </div>
//                   <div className="result-row">
//                     <span>Supply Type:</span>
//                     <strong>{calculationResult.supplyType === 'intra-state' ? 'Intra-State (CGST+SGST)' : 'Inter-State (IGST)'}</strong>
//                   </div>
                  
//                   {calculationResult.cgst && (
//                     <>
//                       <div className="result-row">
//                         <span>CGST ({calculationResult.cgst.rate}%):</span>
//                         <strong>₹{calculationResult.cgst.amount?.toFixed(2)}</strong>
//                       </div>
//                       <div className="result-row">
//                         <span>SGST ({calculationResult.sgst.rate}%):</span>
//                         <strong>₹{calculationResult.sgst.amount?.toFixed(2)}</strong>
//                       </div>
//                     </>
//                   )}
                  
//                   {calculationResult.igst && (
//                     <div className="result-row">
//                       <span>IGST ({calculationResult.igst.rate}%):</span>
//                       <strong>₹{calculationResult.igst.amount?.toFixed(2)}</strong>
//                     </div>
//                   )}
                  
//                   <div className="result-row total">
//                     <span>Total GST:</span>
//                     <strong>₹{calculationResult.totalGST?.toFixed(2)}</strong>
//                   </div>
                  
//                   <div className="result-row grand-total">
//                     <span>Total Amount (Including GST):</span>
//                     <strong>₹{calculationResult.totalAmount?.toFixed(2)}</strong>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {activeTab === 'calculator' && loading && <SkeletonCalculator />}

//       {activeTab === 'reports' && !loading && summary && (
//         <div className="tab-content">
//           <div className="summary-cards">
//             <div className="summary-card">
//               <h4>Total Active Rates</h4>
//               <p className="summary-value">{summary.totalActiveRates}</p>
//             </div>
//             <div className="summary-card">
//               <h4>GSTIN</h4>
//               <p className="summary-value">{summary.config?.gstin || 'Not configured'}</p>
//             </div>
//             <div className="summary-card">
//               <h4>Financial Year</h4>
//               <p className="summary-value">{summary.config?.financialYear || 'N/A'}</p>
//             </div>
//           </div>

//           <div className="reports-section">
//             <h3>Current Active GST Rates</h3>
//             <div className="current-rates-grid">
//               {Object.entries(currentRates).map(([serviceType, rates]) => (
//                 <div key={serviceType} className="rate-card">
//                   <h4>{serviceTypes.find(s => s.value === serviceType)?.label || serviceType}</h4>
//                   {rates.map(rate => (
//                     <div key={rate._id} className="rate-item">
//                       <span className="rate-tax-type">{rate.taxType}</span>
//                       <span className="rate-percentage">{rate.rate}%</span>
//                     </div>
//                   ))}
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="reports-section">
//             <h3>Rate Change History</h3>
//             <div className="table-container">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>Tax Type</th>
//                     <th>Service Type</th>
//                     <th>Rate</th>
//                     <th>Status</th>
//                     <th>Created By</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rateHistory.slice(0, 20).map(history => (
//                     <tr key={history._id}>
//                       <td>{new Date(history.createdAt).toLocaleDateString()}</td>
//                       <td>{history.taxType}</td>
//                       <td>{serviceTypes.find(s => s.value === history.serviceType)?.label || history.serviceType}</td>
//                       <td className="rate-value">{history.rate}%</td>
//                       <td>{getStatusBadge(history.isActive, history.applicableTo)}</td>
//                       <td>{history.createdBy?.name || 'System'}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {activeTab === 'reports' && loading && <SkeletonReports />}

//       {showRateModal && !loading && (
//         <div className="modal-overlay" onClick={() => {
//           setShowRateModal(false);
//           setEditingRate(null);
//           resetRateForm();
//         }}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>{editingRate ? 'Edit GST Rate' : 'Create New GST Rate'}</h3>
//               <button className="modal-close" onClick={() => {
//                 setShowRateModal(false);
//                 setEditingRate(null);
//                 resetRateForm();
//               }}>×</button>
//             </div>
//             <form onSubmit={editingRate ? handleUpdateRate : handleCreateRate}>
//               <div className="modal-body">
//                 <div className="form-group">
//                   <label>Tax Type *</label>
//                   <select name="taxType" value={rateForm.taxType} onChange={handleRateFormChange} required>
//                     {taxTypes.map(type => (
//                       <option key={type} value={type}>{type}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Service Type *</label>
//                   <select name="serviceType" value={rateForm.serviceType} onChange={handleRateFormChange} required>
//                     {serviceTypes.map(type => (
//                       <option key={type.value} value={type.value}>{type.label}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Rate (%) *</label>
//                   <input
//                     type="number"
//                     name="rate"
//                     step="0.1"
//                     value={rateForm.rate}
//                     onChange={handleRateFormChange}
//                     required
//                     placeholder="e.g., 2.5"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>HSN/SAC Code</label>
//                   <input
//                     type="text"
//                     name="hsnSacCode"
//                     value={rateForm.hsnSacCode}
//                     onChange={handleRateFormChange}
//                     placeholder="9964"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Description</label>
//                   <textarea
//                     name="description"
//                     value={rateForm.description}
//                     onChange={handleRateFormChange}
//                     rows="2"
//                     placeholder="Optional description"
//                   />
//                 </div>
                
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Applicable From</label>
//                     <input
//                       type="date"
//                       name="applicableFrom"
//                       value={rateForm.applicableFrom}
//                       onChange={handleRateFormChange}
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Applicable To (Optional)</label>
//                     <input
//                       type="date"
//                       name="applicableTo"
//                       value={rateForm.applicableTo}
//                       onChange={handleRateFormChange}
//                     />
//                   </div>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Priority (Higher = Higher Priority)</label>
//                   <input
//                     type="number"
//                     name="priority"
//                     value={rateForm.priority}
//                     onChange={handleRateFormChange}
//                     min="0"
//                   />
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button type="button" className="btn-secondary" onClick={() => {
//                   setShowRateModal(false);
//                   setEditingRate(null);
//                   resetRateForm();
//                 }}>Cancel</button>
//                 <button type="submit" className="btn-primary" disabled={loading}>
//                   {loading ? 'Saving...' : (editingRate ? 'Update' : 'Create')}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {showRateModal && loading && <SkeletonModal />}

//       {showBulkModal && (
//         <div className="modal-overlay" onClick={() => setShowBulkModal(false)}>
//           <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bulk Import GST Rates</h3>
//               <button className="modal-close" onClick={() => setShowBulkModal(false)}>×</button>
//             </div>
//             <div className="modal-body">
//               <div className="form-group">
//                 <label>CSV Format (taxType, serviceType, rate, description)</label>
//                 <textarea
//                   value={bulkRatesText}
//                   onChange={(e) => setBulkRatesText(e.target.value)}
//                   rows="10"
//                   placeholder={`CGST, ac_bus, 2.5, CGST for AC Bus
// SGST, ac_bus, 2.5, SGST for AC Bus
// IGST, ac_bus, 5, IGST for AC Bus
// CGST, luxury_bus, 2.5, CGST for Luxury Bus`}
//                   className="bulk-textarea"
//                 />
//                 <small>One rate per line, fields separated by commas</small>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="btn-secondary" onClick={() => setShowBulkModal(false)}>Cancel</button>
//               <button className="btn-primary" onClick={handleBulkCreate}>Import Rates</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {viewingRate && (
//         <div className="modal-overlay" onClick={() => setViewingRate(null)}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>GST Rate Details</h3>
//               <button className="modal-close" onClick={() => setViewingRate(null)}>×</button>
//             </div>
//             <div className="modal-body">
//               <div className="detail-row">
//                 <label>Tax Type:</label>
//                 <span className={`tax-badge ${viewingRate.taxType.toLowerCase()}`}>{viewingRate.taxType}</span>
//               </div>
//               <div className="detail-row">
//                 <label>Service Type:</label>
//                 <span>{serviceTypes.find(s => s.value === viewingRate.serviceType)?.label || viewingRate.serviceType}</span>
//               </div>
//               <div className="detail-row">
//                 <label>Rate:</label>
//                 <span className="rate-value">{viewingRate.rate}%</span>
//               </div>
//               <div className="detail-row">
//                 <label>HSN/SAC Code:</label>
//                 <span>{viewingRate.hsnSacCode}</span>
//               </div>
//               <div className="detail-row">
//                 <label>Description:</label>
//                 <span>{viewingRate.description || 'N/A'}</span>
//               </div>
//               <div className="detail-row">
//                 <label>Applicable From:</label>
//                 <span>{new Date(viewingRate.applicableFrom).toLocaleDateString()}</span>
//               </div>
//               <div className="detail-row">
//                 <label>Applicable To:</label>
//                 <span>{viewingRate.applicableTo ? new Date(viewingRate.applicableTo).toLocaleDateString() : 'Ongoing'}</span>
//               </div>
//               <div className="detail-row">
//                 <label>Priority:</label>
//                 <span>{viewingRate.priority}</span>
//               </div>
//               <div className="detail-row">
//                 <label>Status:</label>
//                 <span>{getStatusBadge(viewingRate.isActive, viewingRate.applicableTo)}</span>
//               </div>
//               <div className="detail-row">
//                 <label>Created:</label>
//                 <span>{new Date(viewingRate.createdAt).toLocaleString()}</span>
//               </div>
//               <div className="detail-row">
//                 <label>Last Updated:</label>
//                 <span>{new Date(viewingRate.updatedAt).toLocaleString()}</span>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="btn-secondary" onClick={() => setViewingRate(null)}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default GSTManagement;

import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (pagination…)
import '../../Styles/CustomerReport.css';       // cr- additions (error bar, summary strip)
import '../../Styles/GSTManagement.css';        // GST-only additions (load LAST)
import {
  createGSTRate, getAllGSTRates, updateGSTRate, deleteGSTRate, getActiveGSTRates,
  getGSTConfig, updateGSTConfig, calculateGST, getGSTRateHistory, getGSTSummary, bulkCreateGSTRates
} from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Pagination } from './PrimaryUI';

// ---------- constants / helpers ----------
const SERVICE_TYPES = [
  { value: 'ac_bus', label: 'AC Bus' },
  { value: 'non_ac_bus', label: 'Non-AC Bus' },
  { value: 'luxury_bus', label: 'Luxury Bus' },
  { value: 'sleeper_bus', label: 'Sleeper Bus' }
];
const TAX_TYPES = ['CGST', 'SGST', 'IGST'];
const TABS = [
  { key: 'rates', label: 'GST Rates', icon: 'list' },
  { key: 'config', label: 'Configuration', icon: 'edit' },
  { key: 'calculator', label: 'Calculator', icon: 'wallet' },
  { key: 'reports', label: 'Reports', icon: 'ticket' }
];

const today = () => new Date().toISOString().split('T')[0];
const emptyRate = () => ({
  taxType: 'CGST', serviceType: 'ac_bus', rate: '', hsnSacCode: '9964',
  description: '', applicableFrom: today(), applicableTo: '', priority: 0
});
const serviceLabel = (v) => SERVICE_TYPES.find(s => s.value === v)?.label || v;
const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-GB').replace(/\//g, '.') : 'N/A');
const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const errMsg = (err, fallback) => err?.response?.data?.message || err?.message || fallback;

const statusOf = (isActive, applicableTo) => {
  if (!isActive) return { cls: 'inactive', label: 'Inactive' };
  if (applicableTo && new Date(applicableTo) < new Date()) return { cls: 'pending', label: 'Expired' };
  return { cls: 'active', label: 'Active' };
};
const StatusPill = ({ isActive, applicableTo }) => {
  const s = statusOf(isActive, applicableTo);
  return <span className={`prm-status ${s.cls}`}>{s.label}</span>;
};
const TaxBadge = ({ type }) => <span className={`gst-tax ${(type || '').toLowerCase()}`}>{type}</span>;

const Skeleton = ({ n = 3 }) => (
  <div className="prm-grid">
    {Array.from({ length: n }).map((_, i) => (
      <div className="prm-skel" key={i}><div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" /></div>
    ))}
  </div>
);

// ============================================================
// MAIN
// ============================================================
const GSTManagement = () => {
  const { token } = useSelector(state => state.user);

  const [activeTab, setActiveTab] = useState('rates');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  // rates
  const [rates, setRates] = useState([]);
  const [filters, setFilters] = useState({ taxType: '', serviceType: '', isActive: 'true' });
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  // modals
  const [showRateModal, setShowRateModal] = useState(false);
  const [editingRate, setEditingRate] = useState(null);
  const [rateForm, setRateForm] = useState(emptyRate());
  const [viewingRate, setViewingRate] = useState(null);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkText, setBulkText] = useState('');

  // config
  const [config, setConfig] = useState(null);

  // calculator
  const [calc, setCalc] = useState({ amount: '', serviceType: 'ac_bus', placeOfSupply: '', placeOfConsumption: '' });
  const [calcResult, setCalcResult] = useState(null);
  const [calculating, setCalculating] = useState(false);

  // reports
  const [history, setHistory] = useState([]);
  const [summary, setSummary] = useState(null);
  const [currentRates, setCurrentRates] = useState({});

  // ---------- fetchers ----------
  const fetchRates = useCallback(async () => {
    try {
      setLoading(true); setError(null);
      const res = await getAllGSTRates({ page, limit: pageSize, ...filters }, token);
      if (res?.success) {
        setRates(res.data?.rates || []);
        setTotal(res.data?.pagination?.total || 0);
      } else {
        setError(res?.message || 'Failed to fetch GST rates');
        setRates([]); setTotal(0);
      }
    } catch (err) {
      setError(errMsg(err, 'Failed to fetch GST rates'));
      setRates([]); setTotal(0);
    } finally { setLoading(false); }
  }, [page, pageSize, filters, token]);

  const fetchConfig = useCallback(async () => {
    try {
      setLoading(true); setError(null);
      const res = await getGSTConfig(token);
      if (res?.success) setConfig(res.data || null);
      else { setError(res?.message || 'Failed to fetch GST configuration'); setConfig(null); }
    } catch (err) {
      setError(errMsg(err, 'Failed to fetch GST configuration')); setConfig(null);
    } finally { setLoading(false); }
  }, [token]);

  const fetchReports = useCallback(async () => {
    try {
      setLoading(true); setError(null);
      const [h, s, c] = await Promise.all([getGSTRateHistory(token), getGSTSummary(token), getActiveGSTRates(token)]);
      setHistory(h?.success ? (h.data?.history || []) : []);
      setSummary(s?.success ? (s.data || null) : null);
      setCurrentRates(c?.success ? (c.data?.grouped || {}) : {});
    } catch (err) {
      setError('Failed to fetch reports');
      setHistory([]); setSummary(null); setCurrentRates({});
    } finally { setLoading(false); }
  }, [token]);

  useEffect(() => {
    if (activeTab === 'rates') fetchRates();
    else if (activeTab === 'config') fetchConfig();
    else if (activeTab === 'reports') fetchReports();
    else setLoading(false);
  }, [activeTab, fetchRates, fetchConfig, fetchReports]);

  // keep the page valid if the total shrinks
  useEffect(() => { if (page > totalPages) setPage(totalPages); }, [page, totalPages]);

  const changeFilter = (key, value) => { setFilters(p => ({ ...p, [key]: value })); setPage(1); };
  const clearFilters = () => { setFilters({ taxType: '', serviceType: '', isActive: 'true' }); setPage(1); };

  // ---------- rate handlers ----------
  const closeRateModal = () => { setShowRateModal(false); setEditingRate(null); setRateForm(emptyRate()); };
  const openCreate = () => { setEditingRate(null); setRateForm(emptyRate()); setShowRateModal(true); };
  const openEdit = (r) => {
    setEditingRate(r);
    setRateForm({
      taxType: r.taxType, serviceType: r.serviceType, rate: r.rate,
      hsnSacCode: r.hsnSacCode || '9964', description: r.description || '',
      applicableFrom: r.applicableFrom?.split('T')[0] || today(),
      applicableTo: r.applicableTo?.split('T')[0] || '', priority: r.priority || 0
    });
    setShowRateModal(true);
  };
  const setRF = (name, value) => setRateForm(p => ({ ...p, [name]: value }));

  const handleSaveRate = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const res = editingRate ? await updateGSTRate(editingRate._id, rateForm, token) : await createGSTRate(rateForm, token);
      if (res?.success) {
        toast.success(`GST rate ${editingRate ? 'updated' : 'created'} successfully`);
        closeRateModal();
        fetchRates();
      } else toast.error(res?.message || 'Failed to save GST rate');
    } catch (err) { toast.error(errMsg(err, 'Failed to save GST rate')); }
    finally { setSaving(false); }
  };

  const handleDeleteRate = async (id) => {
    if (!window.confirm('Are you sure you want to deactivate this GST rate?')) return;
    try {
      setSaving(true);
      const res = await deleteGSTRate(id, token);
      if (res?.success) { toast.success('GST rate deactivated'); fetchRates(); }
      else toast.error(res?.message || 'Failed to deactivate GST rate');
    } catch (err) { toast.error(errMsg(err, 'Failed to deactivate GST rate')); }
    finally { setSaving(false); }
  };

  const handleBulkCreate = async () => {
    const arr = bulkText.split('\n').filter(l => l.trim()).map(line => {
      const [taxType, serviceType, rate, ...rest] = line.split(',');
      return {
        taxType: taxType?.trim(), serviceType: serviceType?.trim(), rate: parseFloat(rate),
        description: rest.join(',').trim() || `${taxType?.trim()} ${rate?.trim()}% for ${serviceType?.trim()}`
      };
    });
    if (arr.length === 0) return toast.warning('Add at least one line to import');
    if (arr.some(r => !r.taxType || !r.serviceType || Number.isNaN(r.rate))) return toast.error('Each line needs taxType, serviceType and a numeric rate');
    try {
      setSaving(true);
      const res = await bulkCreateGSTRates(arr, token);
      if (res?.success) {
        toast.success(`Created ${res.data?.created?.length || 0} rates successfully`);
        setShowBulkModal(false); setBulkText(''); fetchRates();
      } else toast.error(res?.message || 'Failed to bulk create rates');
    } catch (err) { toast.error(errMsg(err, 'Failed to bulk create rates')); }
    finally { setSaving(false); }
  };

  // ---------- config handlers ----------
  const setCfg = (name, value) => setConfig(p => ({ ...p, [name]: value }));
  const setAddr = (name, value) => setConfig(p => ({ ...p, address: { ...p.address, [name]: value } }));
  const setDefaultRate = (cat, field, value) => setConfig(p => ({
    ...p,
    defaultRates: {
      ...p.defaultRates,
      [cat]: { ...p.defaultRates?.[cat], [field]: typeof value === 'boolean' ? value : parseFloat(value) || 0 }
    }
  }));

  const handleSaveConfig = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const res = await updateGSTConfig(config, token);
      if (res?.success) toast.success('GST configuration updated');
      else toast.error(res?.message || 'Failed to update configuration');
    } catch (err) { toast.error(errMsg(err, 'Failed to update configuration')); }
    finally { setSaving(false); }
  };

  // ---------- calculator ----------
  const handleCalculate = async () => {
    if (!calc.amount || Number(calc.amount) <= 0) return toast.warning('Enter a valid amount');
    try {
      setCalculating(true);
      const res = await calculateGST(calc, token);
      if (res?.success) setCalcResult(res.data || null);
      else { toast.error(res?.message || 'Failed to calculate GST'); setCalcResult(null); }
    } catch (err) { toast.error(errMsg(err, 'Failed to calculate GST')); setCalcResult(null); }
    finally { setCalculating(false); }
  };

  // ---------- derived ----------
  const activeOnPage = rates.filter(r => statusOf(r.isActive, r.applicableTo).label === 'Active').length;
  const expiredOnPage = rates.filter(r => statusOf(r.isActive, r.applicableTo).label === 'Expired').length;
  const inactiveOnPage = rates.filter(r => !r.isActive).length;
  const filtersApplied = filters.taxType || filters.serviceType || filters.isActive !== 'true';

  const heroText = useMemo(() => ({
    rates: 'Create, edit and retire the GST rates applied to every bus service.',
    config: 'Maintain your GSTIN, business address and default tax rates.',
    calculator: 'Quickly check CGST, SGST or IGST for any fare amount.',
    reports: 'Review current active rates and the full rate change history.'
  }[activeTab]), [activeTab]);

  const refresh = () => {
    if (activeTab === 'rates') fetchRates();
    else if (activeTab === 'config') fetchConfig();
    else if (activeTab === 'reports') fetchReports();
  };

  const retry = refresh;

  // ============================================================
  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true"><span className="prm-hero-roadbus"><BusSvg size={46} /></span></div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="wallet" size={13} /> Tax &amp; Compliance</span>
          <h1>GST Management</h1>
          <p>{heroText}</p>
        </div>
        <div className="prm-hero-actions">
          {activeTab !== 'calculator' && (
            <button className="pbo-icon-btn" onClick={refresh} title="Refresh"><Icon name="refresh" size={17} /></button>
          )}
          {activeTab === 'rates' && (
            <>
              <button className="prm-btn ghost" onClick={() => setShowBulkModal(true)}><Icon name="download" size={14} /> Bulk import</button>
              <button className="prm-add-btn" onClick={openCreate}><span className="plus">+</span> Add GST rate</button>
            </>
          )}
        </div>
      </div>

      {error && (
        <div className="cr-error"><Icon name="info" size={16} /> {error}
          <button className="prm-btn ghost sm" onClick={retry}>Retry</button></div>
      )}

      {/* TABS */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            {TABS.map(t => (
              <button key={t.key} className={`prm-chip ${activeTab === t.key ? 'active' : ''}`}
                onClick={() => { setActiveTab(t.key); setError(null); }}>
                <Icon name={t.icon} size={14} /> {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ================= RATES ================= */}
      {activeTab === 'rates' && (
        <>
          <div className="prm-stats">
            <StatCard icon="list" tone="indigo" label="Total Rates" value={total} hint="Matching current filters" delay={80} />
            <StatCard icon="check" tone="green" label="Active" value={activeOnPage} hint="Active on this page" delay={160} />
            <StatCard icon="calendar" tone="amber" label="Expired" value={expiredOnPage} hint="Past applicable date" delay={240} />
            <StatCard icon="info" tone="cyan" label="Inactive" value={inactiveOnPage} hint="Deactivated on this page" delay={320} />
          </div>

          <div className="prm-toolbar">
            <div className="prm-toolbar-left gst-filters">
              <select className="prm-input prm-select" value={filters.taxType} onChange={e => changeFilter('taxType', e.target.value)}>
                <option value="">All tax types</option>
                {TAX_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
              <select className="prm-input prm-select" value={filters.serviceType} onChange={e => changeFilter('serviceType', e.target.value)}>
                <option value="">All service types</option>
                {SERVICE_TYPES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
              <select className="prm-input prm-select" value={filters.isActive} onChange={e => changeFilter('isActive', e.target.value)}>
                <option value="true">Active only</option>
                <option value="false">Inactive only</option>
                <option value="">All statuses</option>
              </select>
              {filtersApplied && <button className="prm-btn ghost sm" onClick={clearFilters}>Reset</button>}
            </div>
            <div className="prm-toolbar-right">
              <span className="prm-result-count">Showing <b>{rates.length}</b> of {total}</span>
            </div>
          </div>

          <div className={loading ? 'cr-loading' : ''}>
            {loading && rates.length === 0 ? <Skeleton /> : rates.length === 0 ? (
              <div className="prm-empty">
                <div className="icon"><Icon name="list" size={44} /></div>
                <h3>No GST rates found</h3>
                <p>{filtersApplied ? 'Try different filters.' : 'Add your first GST rate to get started.'}</p>
                {filtersApplied
                  ? <button className="prm-btn ghost" onClick={clearFilters}>Reset filters</button>
                  : <button className="prm-btn primary" onClick={openCreate}>+ Add GST rate</button>}
              </div>
            ) : (
              <div className="prm-table-wrap">
                <table className="prm-table">
                  <thead>
                    <tr><th>No.</th><th>Tax</th><th>Service</th><th>Rate</th><th>HSN/SAC</th><th>Valid from</th><th>Valid to</th><th>Priority</th><th>Status</th><th>Actions</th></tr>
                  </thead>
                  <tbody>
                    {rates.map((r, i) => (
                      <tr key={r._id} style={{ animationDelay: `${i * 50}ms` }}>
                        <td>{(page - 1) * pageSize + i + 1}</td>
                        <td><TaxBadge type={r.taxType} /></td>
                        <td>{serviceLabel(r.serviceType)}</td>
                        <td><span className="gst-rate">{r.rate}%</span></td>
                        <td>{r.hsnSacCode || 'N/A'}</td>
                        <td>{fmtDate(r.applicableFrom)}</td>
                        <td>{r.applicableTo ? fmtDate(r.applicableTo) : 'Ongoing'}</td>
                        <td>{r.priority}</td>
                        <td><StatusPill isActive={r.isActive} applicableTo={r.applicableTo} /></td>
                        <td>
                          <div className="prm-row-actions">
                            <button className="prm-btn view sm icon-only" onClick={() => setViewingRate(r)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                            <button className="prm-btn ghost sm icon-only" onClick={() => openEdit(r)} title="Edit" aria-label="Edit"><Icon name="edit" size={14} /></button>
                            <button className="prm-btn ghost sm gst-danger icon-only" disabled={saving || !r.isActive} onClick={() => handleDeleteRate(r._id)} title="Deactivate" aria-label="Deactivate"><Icon name="ban" size={14} /></button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <Pagination page={page} pageSize={pageSize} total={total}
            onPage={(p) => setPage(Math.min(Math.max(1, p), totalPages))}
            onPageSize={(s) => { setPageSize(s); setPage(1); }}
            sizes={[10, 25, 50, 100]} label="rates" />
        </>
      )}

      {/* ================= CONFIG ================= */}
      {activeTab === 'config' && (
        loading && !config ? <Skeleton n={2} /> : !config ? (
          <div className="prm-empty">
            <div className="icon"><Icon name="edit" size={44} /></div>
            <h3>No configuration found</h3><p>The GST configuration could not be loaded.</p>
            <button className="prm-btn ghost" onClick={fetchConfig}>Try again</button>
          </div>
        ) : (
          <form onSubmit={handleSaveConfig} className={`gst-panel ${loading ? 'cr-loading' : ''}`}>
            <div className="prm-section-title">Business information</div>
            <div className="prm-fgrid">
              <Field label="GSTIN" required><input className="prm-input" value={config.gstin || ''} placeholder="22AAAAA0000A1Z5" required onChange={e => setCfg('gstin', e.target.value.toUpperCase())} /></Field>
              <Field label="Legal name" required><input className="prm-input" value={config.legalName || ''} required onChange={e => setCfg('legalName', e.target.value)} /></Field>
              <Field label="Trade name"><input className="prm-input" value={config.tradeName || ''} onChange={e => setCfg('tradeName', e.target.value)} /></Field>
              <Field label="Financial year"><input className="prm-input" value={config.financialYear || ''} placeholder="2026-27" onChange={e => setCfg('financialYear', e.target.value)} /></Field>
            </div>

            <div className="prm-section-title">Registered address</div>
            <div className="prm-fgrid">
              <Field label="Street"><input className="prm-input" value={config.address?.street || ''} onChange={e => setAddr('street', e.target.value)} /></Field>
              <Field label="City"><input className="prm-input" value={config.address?.city || ''} onChange={e => setAddr('city', e.target.value)} /></Field>
              <Field label="State"><input className="prm-input" value={config.address?.state || ''} onChange={e => setAddr('state', e.target.value)} /></Field>
              <Field label="State code"><input className="prm-input" value={config.address?.stateCode || ''} onChange={e => setAddr('stateCode', e.target.value)} /></Field>
              <Field label="Pincode"><input className="prm-input" value={config.address?.pincode || ''} onChange={e => setAddr('pincode', e.target.value)} /></Field>
            </div>

            <div className="prm-section-title">Default GST rates</div>
            <div className="gst-service-grid">
              {SERVICE_TYPES.map(s => {
                const d = config.defaultRates?.[s.value] || {};
                return (
                  <div key={s.value} className={`gst-service ${d.isTaxable ? '' : 'off'}`}>
                    <div className="gst-service-head">
                      <h4>{s.label}</h4>
                      <label className="gst-switch">
                        <input type="checkbox" checked={!!d.isTaxable} onChange={e => setDefaultRate(s.value, 'isTaxable', e.target.checked)} />
                        <span className="track" /><span className="txt">{d.isTaxable ? 'Taxable' : 'Exempt'}</span>
                      </label>
                    </div>
                    <div className="gst-service-inputs">
                      {['cgst', 'sgst', 'igst'].map(f => (
                        <Field key={f} label={`${f.toUpperCase()} (%)`}>
                          <input type="number" step="0.1" min="0" className="prm-input" disabled={!d.isTaxable}
                            value={d[f] ?? 0} onChange={e => setDefaultRate(s.value, f, e.target.value)} />
                        </Field>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="prm-section-title">Additional settings</div>
            <div className="gst-checks">
              <label className="gst-check"><input type="checkbox" checked={!!config.reverseChargeApplicable} onChange={e => setCfg('reverseChargeApplicable', e.target.checked)} /> Reverse charge applicable</label>
              <label className="gst-check"><input type="checkbox" checked={!!config.isEcommerceOperator} onChange={e => setCfg('isEcommerceOperator', e.target.checked)} /> E-commerce operator</label>
            </div>

            <div className="gst-panel-foot">
              <button type="submit" className="prm-btn primary" disabled={saving}>{saving ? 'Saving…' : 'Save configuration'}</button>
            </div>
          </form>
        )
      )}

      {/* ================= CALCULATOR ================= */}
      {activeTab === 'calculator' && (
        <div className="gst-calc">
          <div className="gst-panel">
            <div className="prm-section-title">Calculate GST</div>
            <div className="prm-fgrid one">
              <Field label="Amount (₹)" required>
                <input type="number" min="0" className="prm-input" value={calc.amount} placeholder="Enter fare amount" onChange={e => setCalc({ ...calc, amount: e.target.value })} />
              </Field>
              <Field label="Service type">
                <select className="prm-input prm-select" value={calc.serviceType} onChange={e => setCalc({ ...calc, serviceType: e.target.value })}>
                  {SERVICE_TYPES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                </select>
              </Field>
              <Field label="Place of supply (state code)">
                <input className="prm-input" value={calc.placeOfSupply} placeholder="e.g. 19 for West Bengal" onChange={e => setCalc({ ...calc, placeOfSupply: e.target.value })} />
              </Field>
              <Field label="Place of consumption (state code)">
                <input className="prm-input" value={calc.placeOfConsumption} placeholder="e.g. 27 for Maharashtra" onChange={e => setCalc({ ...calc, placeOfConsumption: e.target.value })} />
              </Field>
            </div>
            <div className="gst-panel-foot">
              <button className="prm-btn primary" onClick={handleCalculate} disabled={calculating}>{calculating ? 'Calculating…' : 'Calculate GST'}</button>
            </div>
          </div>

          <div className="gst-panel gst-result">
            <div className="prm-section-title">Result</div>
            {!calcResult ? (
              <div className="gst-result-empty"><Icon name="wallet" size={38} /><p>Enter an amount and press <b>Calculate GST</b> to see the breakdown.</p></div>
            ) : (
              <>
                <div className="gst-result-total">
                  <span>Total amount (incl. GST)</span><b>{inr(calcResult.totalAmount)}</b>
                </div>
                <div className="gst-result-rows">
                  <div><span>Taxable value</span><b>{inr(calcResult.taxableValue)}</b></div>
                  <div><span>Supply type</span><b>{calcResult.supplyType === 'intra-state' ? 'Intra-state (CGST + SGST)' : 'Inter-state (IGST)'}</b></div>
                  {calcResult.cgst && <div><span>CGST ({calcResult.cgst.rate}%)</span><b>{inr(calcResult.cgst.amount)}</b></div>}
                  {calcResult.sgst && <div><span>SGST ({calcResult.sgst.rate}%)</span><b>{inr(calcResult.sgst.amount)}</b></div>}
                  {calcResult.igst && <div><span>IGST ({calcResult.igst.rate}%)</span><b>{inr(calcResult.igst.amount)}</b></div>}
                  <div className="sum"><span>Total GST</span><b>{inr(calcResult.totalGST)}</b></div>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* ================= REPORTS ================= */}
      {activeTab === 'reports' && (
        loading && !summary ? <Skeleton /> : (
          <div className={loading ? 'cr-loading' : ''}>
            <div className="prm-stats">
              <StatCard icon="list" tone="indigo" label="Active Rates" value={summary?.totalActiveRates ?? 0} hint="Currently applicable" delay={80} />
              <StatCard icon="ticket" tone="green" label="GSTIN" value={summary?.config?.gstin || 'Not set'} hint="Registered number" delay={160} />
              <StatCard icon="calendar" tone="amber" label="Financial Year" value={summary?.config?.financialYear || 'N/A'} hint="Current period" delay={240} />
            </div>

            <div className="prm-section-title">Current active GST rates</div>
            {Object.keys(currentRates).length === 0 ? (
              <div className="prm-empty"><div className="icon"><Icon name="list" size={44} /></div><h3>No active rates</h3><p>Active rates will be grouped by service here.</p></div>
            ) : (
              <div className="prm-grid">
                {Object.entries(currentRates).map(([service, list], i) => (
                  <div className="prm-card gst-rate-card" key={service} style={{ animationDelay: `${i * 70}ms` }}>
                    <div className="prm-card-top">
                      <div><div className="prm-card-no">Service</div><h3 className="prm-card-title">{serviceLabel(service)}</h3></div>
                    </div>
                    <div className="gst-rate-list">
                      {list.map(r => (
                        <div key={r._id}><TaxBadge type={r.taxType} /><b>{r.rate}%</b></div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="prm-section-title">Rate change history <small>(latest 20)</small></div>
            {history.length === 0 ? (
              <div className="prm-empty"><div className="icon"><Icon name="calendar" size={44} /></div><h3>No history yet</h3><p>Rate changes will be listed here.</p></div>
            ) : (
              <div className="prm-table-wrap">
                <table className="prm-table">
                  <thead><tr><th>Date</th><th>Tax</th><th>Service</th><th>Rate</th><th>Status</th><th>Created by</th></tr></thead>
                  <tbody>
                    {history.slice(0, 20).map((h, i) => (
                      <tr key={h._id} style={{ animationDelay: `${i * 40}ms` }}>
                        <td>{fmtDate(h.createdAt)}</td>
                        <td><TaxBadge type={h.taxType} /></td>
                        <td>{serviceLabel(h.serviceType)}</td>
                        <td><span className="gst-rate">{h.rate}%</span></td>
                        <td><StatusPill isActive={h.isActive} applicableTo={h.applicableTo} /></td>
                        <td>{h.createdBy?.name || 'System'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )
      )}

      {/* ================= RATE MODAL ================= */}
      {showRateModal && (
        <div className="prm-overlay" onClick={closeRateModal}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={e => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
                <div><h3>{editingRate ? 'Edit GST rate' : 'New GST rate'}</h3><p>{editingRate ? `${editingRate.taxType} · ${serviceLabel(editingRate.serviceType)}` : 'Set the tax, service and validity period'}</p></div>
              </div>
              <button className="prm-modal-close" onClick={closeRateModal}>×</button>
            </div>
            <form onSubmit={handleSaveRate}>
              <div className="prm-form-body">
                <div className="prm-fgrid">
                  <Field label="Tax type" required>
                    <select className="prm-input prm-select" value={rateForm.taxType} onChange={e => setRF('taxType', e.target.value)}>
                      {TAX_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                  </Field>
                  <Field label="Service type" required>
                    <select className="prm-input prm-select" value={rateForm.serviceType} onChange={e => setRF('serviceType', e.target.value)}>
                      {SERVICE_TYPES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                    </select>
                  </Field>
                  <Field label="Rate (%)" required>
                    <input type="number" step="0.1" min="0" required className="prm-input" value={rateForm.rate} placeholder="e.g. 2.5" onChange={e => setRF('rate', e.target.value)} />
                  </Field>
                  <Field label="HSN/SAC code">
                    <input className="prm-input" value={rateForm.hsnSacCode} placeholder="9964" onChange={e => setRF('hsnSacCode', e.target.value)} />
                  </Field>
                  <Field label="Applicable from">
                    <input type="date" className="prm-input" value={rateForm.applicableFrom} onChange={e => setRF('applicableFrom', e.target.value)} />
                  </Field>
                  <Field label="Applicable to (optional)">
                    <input type="date" className="prm-input" min={rateForm.applicableFrom} value={rateForm.applicableTo} onChange={e => setRF('applicableTo', e.target.value)} />
                  </Field>
                  <Field label="Priority (higher wins)">
                    <input type="number" min="0" className="prm-input" value={rateForm.priority} onChange={e => setRF('priority', e.target.value)} />
                  </Field>
                </div>
                <Field label="Description">
                  <textarea className="prm-input gst-textarea" rows="2" value={rateForm.description} placeholder="Optional description" onChange={e => setRF('description', e.target.value)} />
                </Field>
              </div>
              <div className="prm-form-foot">
                <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
                <div className="prm-form-foot-actions">
                  <button type="button" className="prm-btn ghost" onClick={closeRateModal}>Cancel</button>
                  <button type="submit" className="prm-btn primary" disabled={saving}>{saving ? 'Saving…' : editingRate ? 'Save changes' : 'Create rate'}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ================= BULK MODAL ================= */}
      {showBulkModal && (
        <div className="prm-overlay" onClick={() => setShowBulkModal(false)}>
          <div className="prm-form-modal" onClick={e => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="download" size={22} /></span>
                <div><h3>Bulk import GST rates</h3><p>taxType, serviceType, rate, description</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setShowBulkModal(false)}>×</button>
            </div>
            <div className="prm-form-body">
              <Field label="Rates (one per line)">
                <textarea className="prm-input gst-textarea gst-mono" rows="9" value={bulkText} onChange={e => setBulkText(e.target.value)}
                  placeholder={`CGST, ac_bus, 2.5, CGST for AC Bus\nSGST, ac_bus, 2.5, SGST for AC Bus\nIGST, ac_bus, 5, IGST for AC Bus`} />
              </Field>
              <p className="gst-hint">Service types: {SERVICE_TYPES.map(s => s.value).join(', ')}</p>
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">{bulkText.split('\n').filter(l => l.trim()).length} line(s)</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setShowBulkModal(false)}>Cancel</button>
                <button className="prm-btn primary" onClick={handleBulkCreate} disabled={saving}>{saving ? 'Importing…' : 'Import rates'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ================= VIEW MODAL ================= */}
      {viewingRate && (
        <div className="prm-overlay" onClick={() => setViewingRate(null)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={e => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="eye" size={22} /></span>
                <div><h3>{viewingRate.rate}% {viewingRate.taxType}</h3><p>{serviceLabel(viewingRate.serviceType)}</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setViewingRate(null)}>×</button>
            </div>
            <div className="prm-form-body">
              <div className="pbo-mini-stats">
                <div><span>Status</span><b><StatusPill isActive={viewingRate.isActive} applicableTo={viewingRate.applicableTo} /></b></div>
                <div><span>Priority</span><b>{viewingRate.priority}</b></div>
                <div><span>HSN/SAC</span><b>{viewingRate.hsnSacCode || 'N/A'}</b></div>
              </div>
              <div className="gst-details">
                <div><span>Tax type</span><TaxBadge type={viewingRate.taxType} /></div>
                <div><span>Applicable from</span><b>{fmtDate(viewingRate.applicableFrom)}</b></div>
                <div><span>Applicable to</span><b>{viewingRate.applicableTo ? fmtDate(viewingRate.applicableTo) : 'Ongoing'}</b></div>
                <div><span>Description</span><b>{viewingRate.description || 'N/A'}</b></div>
                <div><span>Created</span><b>{new Date(viewingRate.createdAt).toLocaleString()}</b></div>
                <div><span>Last updated</span><b>{new Date(viewingRate.updatedAt).toLocaleString()}</b></div>
              </div>
            </div>
            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setViewingRate(null)}>Close</button>
                <button className="prm-btn primary" onClick={() => { const r = viewingRate; setViewingRate(null); openEdit(r); }}>Edit rate</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GSTManagement;